export enum CertificateType {
    V2GRootCertificate,
    MoRootCertificate,
    CsmsRootCertificate,
    V2GCertificateChain,
    ManufacturerRootCertificate,
    ChargingStationCertificate
}
